import { render, staticRenderFns } from "./LandingBlogDetail.vue?vue&type=template&id=33f5b9f0&scoped=true"
import script from "./LandingBlogDetail.vue?vue&type=script&lang=js"
export * from "./LandingBlogDetail.vue?vue&type=script&lang=js"
import style0 from "./LandingBlogDetail.vue?vue&type=style&index=0&id=33f5b9f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f5b9f0",
  null
  
)

export default component.exports